import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { Button, Card, Col, Row, Table, Form, Modal } from "react-bootstrap";
import Layout from '../../layout/Layout';
import Pagination from "rc-pagination";
import Switch from 'react-switch';
import $ from 'jquery'
import { NewsAll, NewsDelete, NewsSearch, NewsStatus } from "../../Auth/Api";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import Copy from "copy-to-clipboard";


const News = () => {

    const [perPage, setPerPage] = useState(10);
    const [size, setSize] = useState(perPage);
    const [current, setCurrent] = useState(1);
    const [Data, SetData] = useState([])
    const [NewDesc, SetNewDesc] = useState()
    const [show, setShow] = useState(false);
    const [loading, Setloading] = useState(true)
    const [iconcoror, Seticoncoror] = useState("title_up")
    const [index, Setindex] = useState([])
    const [Search, SetSearch] = useState({
        title: ""
    })


    const handleClose = () => {
        setShow(false);
    }
    const handleShow = (desc) => {
        setShow(true);
        SetNewDesc(desc)
    }

    const GetData = async () => {
        const Result = await NewsAll()
        if (Result.data.Status === true) {
            SetData(Result.data.Data)
            Setloading(false)
            $('#remove_tr').empty()
            var id = []
            Result.data.Data.map(async (val) => {
                id.push(val._id)
            })
            Setindex(id)
        }
        else {
            SetData([])
            Setloading(false)
            $('#remove_tr').empty()
            $('#remove_tr').append('<td colSpan="100%" class="p-0"><div class="no-found"><img src="../../not-found/news.svg"/><p>No Found News</p></div></td>')
        }
    }

    const sorting = (col, type = "string", order, e) => {
        Seticoncoror(e.target.id)
        if (order === "ASC") {
            const sorted = [...Data].sort((a, b) =>
                a[col] > b[col] ? 1 : -1
            );
            if (iconcoror !== e.target.id) {
                SetData(sorted)
            }
        }
        if (order === "DSC") {
            const sorted = [...Data].sort((a, b) =>
                a[col] < b[col] ? 1 : -1
            );
            if (iconcoror !== e.target.id) {
                SetData(sorted)
            }
        }
    }

    const DeleteNews = async (id) => {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: "btn btn-success",
                cancelButton: "btn btn-danger me-2",
            },
            buttonsStyling: false,
        });
        swalWithBootstrapButtons
            .fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, delete it!",
                cancelButtonText: "No, cancel! ",
                reverseButtons: true,
            })
            .then(async (result) => {
                if (result.isConfirmed) {
                    Setloading(true)
                    const Result = await NewsDelete(id)
                    if (Result.data.Status === true) {
                        Setloading(false)
                        toast.success("News Delete Successfully...")
                        GetData()
                    }
                    else {
                        toast.error(Result.data.Response_Message)
                    }
                }
            });
    }

    const InputSearch = async (e) => {
        SetSearch({ ...Search, title: e.target.value })
        const Result = await NewsSearch(e.target.value)
        if (Result.data.Status === true) {
            SetData(Result.data.Data)
            $('#remove_tr').empty()
            setCurrent(1)
        }
        else {
            SetData([])
            $('#remove_tr').empty()
            $('#remove_tr').append('<td colSpan="100%" class="p-0"><div class="no-found"><img src="../../../not-found/news.svg"/><p>No Found News</p></div></td>')
        }
    }

    const ChangeStatus = async (e, id) => {
        const Result = await NewsStatus((e === true) ? 1 : 0, id)
        if (Result.data.Status === true) {
            toast.success("Status Update Successfully...")
            if (Search.title !== "") {
                const Result1 = await NewsSearch(Search.title)
                if (Result1.data.Status === true) {
                    SetData(Result1.data.Data)
                }
                else {
                    SetData([])
                }
            }
            else {
                GetData()
            }
        }
        else {
            toast.error(Result.data.Response_Message)
        }
    }

    const CopyNewUrl = async (newsurl) => {
        Copy(newsurl)
        toast.success(`NewsUrl Copy Successfully`);
    }

    const getData = (current, pageSize) => {
        return Data.slice((current - 1) * pageSize, current * pageSize);
    };

    const PerPageChange = (value) => {
        setSize(value);
        const newPerPage = Math.ceil(Data.length / value);
        if (current > newPerPage) {
            setCurrent(newPerPage);
        }
    }

    const PaginationChange = (page, pageSize) => {
        setCurrent(page);
        setSize(pageSize)
    }


    const PrevNextArrow = (current, type, originalElement) => {
        if (type === 'prev') {
            return <button className='paggination-btn'>Previous</button>;
        }
        if (type === 'next') {
            return <button className='paggination-btn'>Next</button>;
        }
        return originalElement;
    }

    useEffect(() => {
        GetData()
    }, [])

    return (
        <Layout sidebar={true}>
            <div className="page-heading">
                <h3 className="my-1">News</h3>
                <div className="page-heading-right">
                    <Form.Control type="text" name="" id="" placeholder="Search Title" onChange={(e) => { InputSearch(e) }} className="wv-200 my-1 ms-3" />
                    <Link to="/News/Add" className="my-1 ms-3">
                        <Button variant="primary" value="create">Add New</Button>
                    </Link>
                </div>
            </div>
            <div className="page-content">
                <Row>
                    <Col xs={12}>
                        <Card>
                            <Card.Body>
                                {(loading === true) ? <div className="loader table-loader" ></div> : <></>}
                                <Table bordered responsive>
                                    <thead>
                                        <tr>
                                            <th width="5%" className="text-center">No</th>
                                            <th width="16%">
                                                <div className='table-sort-filter'>Title
                                                    <span className='table-sort'>
                                                        <div className={`sort-down ${iconcoror === "title_down" ? "active" : ""}`} id="title_down" onClick={(e) => { sorting('title', "", "DSC", e) }}></div>
                                                        <div className={`sort-up ${iconcoror === "title_up" ? "active" : ""}`} id="title_up" onClick={(e) => { sorting('title', "", "ASC", e) }}></div>
                                                    </span>
                                                </div>
                                            </th>
                                            <th width="16%">
                                                <div className='table-sort-filter'>Header
                                                    <span className='table-sort'>
                                                        <div className={`sort-down ${iconcoror === "header_down" ? "active" : ""}`} id="header_down" onClick={(e) => { sorting('header', "", "DSC", e) }}></div>
                                                        <div className={`sort-up ${iconcoror === "header_up" ? "active" : ""}`} id="header_up" onClick={(e) => { sorting('header', "", "ASC", e) }}></div>
                                                    </span>
                                                </div>
                                            </th>
                                            <th width="9%">Latitude</th>
                                            <th width="9%">Longitude</th>
                                            <th width="13%">Location Name</th>
                                            <th width="8%" className="text-center">Webview</th>
                                            <th width="8%" className="text-center">Description</th>
                                            <th width="8%">
                                                <div className='table-sort-filter justify-content-center'>Status
                                                    <span className='table-sort'>
                                                        <div className={`sort-down ${iconcoror === "isactive_down" ? "active" : ""}`} id="isactive_down" onClick={(e) => { sorting('is_active', "", "DSC", e) }}></div>
                                                        <div className={`sort-up ${iconcoror === "isactive_up" ? "active" : ""}`} id="isactive_up" onClick={(e) => { sorting('is_active', "", "ASC", e) }}></div>
                                                    </span>
                                                </div>
                                            </th>
                                            <th width="8%" className='text-center'>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            getData(current, size).map((val, ind) => {
                                                return (
                                                    <tr key={ind}>
                                                        <td className='text-center'>{index.indexOf(val?._id) + 1}</td>
                                                        <td>{val.title}</td>
                                                        <td>{val.header}</td>
                                                        <td>{val.latitude}</td>
                                                        <td>{val.longitude}</td>
                                                        <td>{val.location_name}</td>
                                                        <td className="text-center">
                                                            <Button variant="outline-success" size="sm" className="me-2 btn-icon" onClick={() => { CopyNewUrl(val.news_url) }} ><i className='bx bx-copy'></i></Button>
                                                            <a href={val.news_url} target="_blank" rel="noreferrer" >
                                                                <Button variant="outline-info" size="sm" className="btn-icon" ><i className='bx bx-link-external'></i></Button>
                                                            </a>
                                                        </td>
                                                        <td className="text-center">
                                                            <Button variant="outline-primary" size="sm" className="btn-icon" onClick={() => { handleShow(val.description) }}><i className='bx bx-info-circle'></i></Button>
                                                        </td>
                                                        <td className='text-center'>
                                                            <Switch
                                                                onChange={(e) => { ChangeStatus(e, val._id) }}
                                                                checked={(val.is_active === 1) ? true : false}
                                                                offColor="#C8C8C8"
                                                                onColor="#0093ed"
                                                                height={30}
                                                                width={70}
                                                                className="react-switch"
                                                                uncheckedIcon={
                                                                    <div className="react-switch-off">OFF</div>
                                                                }
                                                                checkedIcon={
                                                                    <div className="react-switch-on">ON</div>
                                                                }
                                                            />
                                                        </td>
                                                        <td className='text-center'>
                                                            <Link to={`/News/View/${val._id}`}>
                                                                <Button variant="outline-warning" size="sm" className="me-2 btn-icon"><i className='bx bx-show'></i></Button>
                                                            </Link>
                                                            <Button variant="outline-danger" size="sm" className="btn-icon" onClick={() => DeleteNews(val._id)}><i className='bx bx-trash-alt' ></i></Button>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                        <tr id="remove_tr"></tr>
                                    </tbody>
                                </Table>
                                {(Data.length > size) ?
                                    <div className="pagination-custom">
                                        <Pagination
                                            className="pagination-data"
                                            onChange={PaginationChange}
                                            total={Data.length}
                                            current={current}
                                            pageSize={size}
                                            showSizeChanger={false}
                                            itemRender={PrevNextArrow}
                                            onShowSizeChange={PerPageChange}
                                            showTitle={false}
                                        />
                                    </div> : ""}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
            <Modal show={show} size="lg" scrollable onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>News Description</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="content" dangerouslySetInnerHTML={{ __html: NewDesc }}></div>
                </Modal.Body>
            </Modal>
        </Layout>
    )
}

export default News